import { useEffect, useState } from "react";

const empty = () => ({ draft: {}, applied: {} });
export function normalizeGenerationChoices(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) throw new Error("Choix illisibles");
  return Object.fromEntries(Object.entries(value).sort(([a], [b]) => a.localeCompare(b)).flatMap(([med, choice]) => {
    if (!choice || typeof choice !== "object" || typeof choice.excluded !== "boolean" || typeof choice.motif !== "string")
      throw new Error("Choix illisibles");
    const motif = choice.motif.slice(0, 300);
    return choice.excluded || motif ? [[med, { excluded: choice.excluded, motif }]] : [];
  }));
}

// Brouillon et choix appliqués restent distincts : seul Relancer change le calcul.
export default function usePr2GenerationChoices(userId, month) {
  const key = userId && /^\d{4}-\d{2}$/.test(month) ? `pr2-equilibrage-choices:v1:${userId}:${month}` : null;
  const [state, setState] = useState({ key: null, ...empty(), error: "" });
  useEffect(() => {
    if (!key) { setState({ key, ...empty(), error: "" }); return; }
    try {
      const raw = window.localStorage.getItem(key);
      const stored = raw ? JSON.parse(raw) : { version: 1, ...empty() };
      if (stored.version !== 1) throw new Error("Version inconnue");
      setState({ key, draft: normalizeGenerationChoices(stored.draft),
        applied: normalizeGenerationChoices(stored.applied), error: "" });
    } catch {
      setState({ key, ...empty(), error: "Les exclusions conservées dans ce navigateur n’ont pas pu être relues. Vérifiez vos choix avant de relancer." });
    }
  }, [key]);
  const ready = Boolean(key && state.key === key);
  function save(next) {
    let error = "";
    try {
      if (!Object.keys(next.draft).length && !Object.keys(next.applied).length) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, JSON.stringify({ version: 1, draft: next.draft, applied: next.applied }));
    } catch {
      error = "Exclusions non conservées : le stockage de ce navigateur est indisponible. Les choix restent dans cet onglet seulement.";
    }
    setState({ key, ...next, error });
  }
  return {
    ready, draft: ready ? state.draft : {}, applied: ready ? state.applied : {},
    pending: ready && JSON.stringify(state.draft) !== JSON.stringify(state.applied),
    error: ready ? state.error : "",
    change(med, patch) {
      if (!ready) return;
      save({ draft: normalizeGenerationChoices({ ...state.draft,
        [med]: { excluded: false, motif: "", ...state.draft[med], ...patch } }), applied: state.applied });
    },
    apply(selection) {
      if (!ready) return;
      save({ draft: state.draft, applied: normalizeGenerationChoices(selection) });
    },
  };
}
